exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body.noscroll,html.noscroll{overflow:hidden;-webkit-overflow-scrolling:auto}@media (max-width:767px){body.noscroll,html.noscroll{position:fixed;top:0;bottom:0;right:0;left:0}}", ""]);

